import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { ButtonCompo } from "../../components/Comman/Button";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import endpoint from "../../config/endpoints";
import * as myConstClass from "../../config/messageconstant";

import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import {
  checkedListEmptyMsg,
  noInternetMsg,
  saveWarningMsg,
  serverMsg,
} from "../../config/messageconstant";
import { assignBeatJson } from "../../DynamicFormsJson/Transaction/assignBeat";
import {
  getAreaByUserType,
  getAreaByUserAndSalesTeamIds,
} from "../../Slice/area.slice";
import {
  getBeatByBeatTypeAndAreas,
  setBeatBySalesTeamIdAreaId,
  setBeatList,
} from "../../Slice/beat.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import { getOutletByBeatId } from "../../Slice/outlet.slice";
import { getRegionUpdated } from "../../Slice/region.slice";
import {
  getSalesExecutiveTypeByUserTypeIdsAndAreaId,
  getSalesExecutive,
  getSalesExecutiveByUserAndStockHolderType,
} from "../../Slice/salesExecutive.slice";
import { getStateByRegion } from "../../Slice/state.slice";
import { getTalukaByDistrict } from "../../Slice/taluka.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import {
  getStockStakeHolderType,
  getStockStakeHolderByOrderLevelWithSelf,
} from "../../Slice/stockStakeHolderType.slice";
import BeatAssignationBySalesTeamWise from "./BeatAssignationBySalesTeamWise";
import { LabelCompo } from "../../components/Comman/Label";
import { titleColor } from "../../config/ColorObj";
import { downloadF } from "../PDF/PDFDownload";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { ValidationCheck, mandatoryCheck } from "../../config/ValidationCheck";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
class AssignBeatAllowanceWiseForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      salesTeamId: "",
      areaId: "",
      setList: [],
      checkList: [],
      isError: false,
      areaName: "",
      salesTeamName: "",
      searchValue: "",
      selection: [],
      allChecked: false,
      open: false,
      DataToSet: [],
      adminFlag: false,
      tabValue: 0,
      tabFlag1: false,
      tabFlag2: true,
      salesExecutivData: {},
      salesTeamLocalityData: {},
      dynamicMasterData: {
        areaDetail: this.props.areaList.areaBySalesTeam,
        salesExecutiveDetail: this.props.salesExecutive.salesExecutive,
        stockStakeHolderTypelistDetail:
          this.props.stockStakeHolderTypeList?.stockStakeHolderType,
      },
      checkedBeatList: [],
      checkedBeatNames: [],
      areaListForName: [],
      beatType: "",
      fieldData: { type: "2" },
      formErrors: {},
    };
  }

  a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }
  handledChange = (e, newValue) => {
    this.setState({
      tabValue: newValue,
      tabFlag1: newValue == 1 ? true : false,
      tabFlag2: newValue == 0 ? true : false,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.stockStakeHolderTypeList !== nextProps.stockStakeHolderTypeList
    ) {
      if (
        this.props.stockStakeHolderTypeList?.stockStakeHolderType !==
        nextProps.stockStakeHolderTypeList?.stockStakeHolderType
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockHolderTypeDetail:
              nextProps.stockStakeHolderTypeList?.stockStakeHolderType,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaBySalesTeam !==
        nextProps.areaList?.areaBySalesTeam
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaBySalesTeam,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (this.props.areaList?.area !== nextProps.areaList?.area) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.area,
          },
        });
      }
    }
    if (this.props.salesExecutive !== nextProps.salesExecutive) {
      if (
        this.props.salesExecutive?.salesExecutive !==
        nextProps.salesExecutive?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesExecutiveDetail: nextProps.salesExecutive?.salesExecutive,
          },
        });
      }
    }
  }

  async componentDidMount() {
    const {
      getAreaByUserType,
      setBeatBySalesTeamIdAreaId,
      getRegionUpdated,
      showLoador,
      showNotification,
      getStockStakeHolderType,
      getStockStakeHolderByOrderLevelWithSelf,
    } = this.props;
    if (navigator.onLine) {
      const userTypeId = localStorage.getItem("userTypeId");

      if (userTypeId == 1 || userTypeId == 6) {
        showLoador({ loador: true });
        getRegionUpdated().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });

        this.setState({
          adminFlag: true,
        });
      }

      setBeatBySalesTeamIdAreaId({ row: [] });

      if (userTypeId != 1 && userTypeId != 6) {
        showLoador({ loador: true });
        getAreaByUserType().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }

      const moduleObjData = localStorage.getItem("moduleObj");

      this.setState({
        fieldDataForModule:
          moduleObjData != null ? JSON.parse(moduleObjData) : {},
      });

      if (userTypeId == 1 || userTypeId == 6 || userTypeId == 2) {
        showLoador({ loador: true });
        await getStockStakeHolderType({ userTypeIds: "3,4" }).then(
          ({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
            }
          }
        );
      } else {
        showLoador({ loador: true });
        await getStockStakeHolderByOrderLevelWithSelf().then(
          ({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
            }
          }
        );
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getAreaByUserAndSalesTeamIds,
      getSalesExecutiveTypeByUserTypeIdsAndAreaId,
      getSalesExecutive,
      getSalesExecutiveByUserAndStockHolderType,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      if (data.stockHolderType && data.stockHolderType != "") {
        showLoador({ loador: true });
        await getSalesExecutiveByUserAndStockHolderType({
          stockStakeHolderId: data.stockHolderType,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }

      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zone && data.zone != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.salesExecutive && data.salesExecutive != "") {
        let salesTeamJson = {
          salesTeamIds: data.salesExecutive.split(","),
        };
        showLoador({ loador: true });
        await getAreaByUserAndSalesTeamIds({
          salesTeamIds: salesTeamJson,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });

        const salesExecutivData =
          this.props.salesExecutive?.salesExecutive.find(
            (row) => row.id === data.salesExecutive
          );
        this.setState({ salesExecutivData });
      }

      if (data.area && data.area != "") {
        let dataToSave = {
          userTypeIds: [3, 4],
          areaIds: [data.area.id],
        };

        showLoador({ loador: true });
        await getSalesExecutiveTypeByUserTypeIdsAndAreaId({
          dataJson: dataToSave,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearch = async (data) => {
    const { getBeatByBeatTypeAndAreas, showLoador, showNotification } =
      this.props;
    const { fieldData } = this.state;

    if (navigator.onLine) {
      if (this.checkValidationOnSubmit()) {

        const areaNameList = this.props.areaList?.areaBySalesTeam.filter((row) =>
          fieldData.areaIds.includes(row.id)
        );

        const salesTeamLocalityData =
          this.props.salesExecutive?.salesExecutive.find(
            (row) => row.id == fieldData.salesExecutive
          );

        this.setState({
          salesTeamLocalityData,
          salesTeamId: fieldData.salesExecutive,
          areaId: fieldData.areaIds,
          areaListForName: areaNameList,
          beatType: fieldData.type,
        });

        let dataToSend = {
          salesTeamId: fieldData.salesExecutive,
          areaIds: typeof fieldData.areaIds === "string" ? fieldData.areaIds.split(",") : fieldData.areaIds,
        };
        showLoador({ loador: true });
        getBeatByBeatTypeAndAreas({
          beatType: fieldData.type,
          jsonData: dataToSend,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            if (response?.length == 0) {
              this.props.showNotification({
                msg: "No Data Found",
                severity: "error",
              });
            }
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  getFormData = () => {
    let tabValue = 1;
    this.setState({
      tabValue: tabValue,
      tabFlag1: tabValue == 1 ? true : false,
    });
  };

  onSubmit = () => {

    const { beatList, showLoador, showNotification } = this.props;
    const { salesTeamId, areaId, beatType } = this.state;
    let filterBeatList = [];
    let hasError = false;
    let checkedBeatNames = [];

    beatList?.beat.length != 0 &&
      beatList?.beat.map((beatObject) => {
        if (beatObject.isChecked) {
          if (beatObject.isError) {
            hasError = true;
          }

          checkedBeatNames.push(beatObject.beatName);

          const beatListObjectToSave = {
            beat: {
              id: beatObject.beatId,
            },
            salesTeam: {
              id: salesTeamId,
            },
            beatType: +beatObject.beatType,
            beatSubType: +beatObject.beatSubType,
            ratePerKm:
              (beatType == 2 && beatObject.beatType == 0) ? 0 :
                (beatType == 0) ? 0 :
                  (beatObject.ratePerKm ? +beatObject.ratePerKm : 0),
            dailyAllowance:
              (beatType == 2 && beatObject.beatType == 1) ? 0 :
                (beatType == 1) ? 0 : (beatObject.dailyAllowance
                  ? +beatObject.dailyAllowance
                  : 0),
            distanceFromHq:
              (beatType == 2 && beatObject.beatType == 0) ? 0 :
                (beatType == 0) ? 0 : (beatObject.distance ? +beatObject.distance : 0),
            selfAssign:
              beatObject.isSelfAssign == 2
                ? 0
                : beatObject.isCheckedForEndUser
                  ? 1
                  : 0,
          };
          filterBeatList.push(beatListObjectToSave);
        }
      });

    this.setState({ checkedBeatNames, checkedBeatList: filterBeatList });

    let dataToSave = {
      salesTeamId: salesTeamId,
      flag: beatType,
      areaIds: typeof areaId === "string" ? areaId.split(",") : areaId,
      beatAssign: filterBeatList,
    };

    console.log(dataToSave);

    if (!hasError) {
      swal({
        title: "Are you sure?",
        text: saveWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          showLoador({ loador: true });
          apiPost({
            url: endpoint.assignBeat + "/save-list-with-info",
            postBody: dataToSave,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (success) {
              showNotification({
                msg: myConstClass.savemsg,
              });
              this.getFormData(salesTeamId);
            } else {
              showNotification({
                msg: myConstClass.saveFailedMsg,
                severity: "error",
              });
            }
          });
        }
      });
    }
  };

  onSearchBox = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  handleAllCheckedClick = (e) => {
    const { beatList, setBeatList } = this.props;
    this.setState({ selection: e });
    this.setState({ allChecked: e.target.checked });
    let dataList = beatList?.beat.map((dataObj) => {
      return {
        ...dataObj,
        isChecked: e.target.checked,
      };
    });
    setBeatList({ row: dataList });
  };

  handleClick = (e, id) => {
    const { beatList, setBeatList } = this.props;
    this.setState({ selection: e });
    let data = beatList?.beat.map((dataObj) => {
      if (dataObj.id == id) {
        return {
          ...dataObj,
          isChecked: e.target.checked,
        };
      } else {
        return dataObj;
      }
    });
    setBeatList({ row: data });
  };

  changeRadioHandler = (e, id) => {
    const { beatList, setBeatList } = this.props;

    let data = beatList?.beat.map((dataObj) => {
      if (dataObj.id == id) {
        return {
          ...dataObj,
          beatSubType: e.target.value,
        };
      } else {
        return dataObj;
      }
    });
    setBeatList({ row: data });
  };

  handleClickOnEndUser = (e, id) => {
    const { beatList, setBeatList } = this.props;
    this.setState({ selection: e });
    let data = beatList?.beat.map((dataObj) => {
      if (dataObj.id == id) {
        return {
          ...dataObj,
          isCheckedForEndUser: e.target.checked,
        };
      } else {
        return dataObj;
      }
    });
    setBeatList({ row: data });
  };

  changeHandler = (row, name) => (e) => {
    const { name, value, placeholder } = e.target;
    const { beatList, setBeatList } = this.props;

    let updatedList = beatList?.beat.map((dataObj) => {
      if (dataObj.id === row.id) {
        return {
          ...dataObj,
          [name]: value,
          [`${name}Error`]:
            value.trim() === "" ? [placeholder] + " cannot be empty" : "",
          isError: value.trim() === "" ? true : false,
        };
      } else {
        return dataObj;
      }
    });

    setBeatList({ row: updatedList });
  };

  getFilteredTableData = (searchData) => {
    const { searchValue } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["beatName"] &&
          currentRow["beatName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["townName"] &&
          currentRow["townName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["areaName"] &&
          currentRow["areaName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["salesTeamName"] &&
          currentRow["salesTeamName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  onCancel = () => {
    window.location.reload();
  };

  generateExcel = () => {
    const { fromDate, toDate, showLoador, showNotification } = this.props;
    const { salesTeamId, areaId } = this.state;
    if (navigator.onLine) {
      let dateJson = {
        salesTeamId: salesTeamId,
        areaIds: typeof areaId === "string" ? areaId.split(",") : areaId,
      };

      showLoador({ loador: true });
      downloadF({
        isGet: false,
        url:
          endpoint.exportData +
          "/get-beat-config-by-beat-type-or-areas-export-excel?beatType=" +
          this.state.beatType,
        postBody: dateJson,
        ext: "xls",
        openNewTab: true,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };



  checkValidationOnSubmit = () => {
    const { fieldData } = this.state;
    const mandatoryCheckErrors = mandatoryCheck({
      fieldData,
      fieldMeta: assignBeatJson.fieldMetaForAllowanceWise,
    });

    console.log(mandatoryCheckErrors);

    this.setState({
      formErrors: mandatoryCheckErrors.formErrors,
    });
    if (mandatoryCheckErrors.formValid) {
      const ValidationCheckErrors = ValidationCheck({
        fieldData,
        fieldMeta: assignBeatJson.fieldMetaForAllowanceWise,
      });
      this.setState({
        formErrors: ValidationCheckErrors.formErrors,
      });
      return ValidationCheckErrors.formValid;
    } else {
      return false;
    }
  };

  onDataChange = (fieldName, newValue) => {

    console.log(fieldName)

    if (fieldName == "type") {
      this.props.setBeatList({ row: [] });
    }

    const { fieldData } = this.state;
    const dataToSearch = {};
    const dataToReset = { ...this.state.fieldData };
    let listError = false;
    assignBeatJson.fieldMetaForAllowanceWise.map((currentField) => {
      if (currentField.getDate && currentField.dataKey === fieldName) {
        dataToReset[currentField.getDate] = newValue.add(365, "day");
      }
      if (currentField.dataKey === fieldName && currentField.getListId) {
        const masterKeyList = currentField.getListId.split(",");
        masterKeyList.map((key) => {
          if (fieldName === key) {
            dataToSearch[key] = newValue;
          } else if (fieldData[key]) {
            dataToSearch[key] = fieldData[key];
          }
          return null;
        });
      }

      if (currentField.dataKey === fieldName && currentField.getListId) {
        const masterKeyList = currentField.getListId.split(",");

        masterKeyList.forEach((key) => {
          if (fieldName === key) {
            dataToSearch[key] = newValue;
          } else if (fieldData[key]) {
            dataToSearch[key] = fieldData[key];
          }
        });

        this.getListById(dataToSearch);
      }
      if (currentField.getListFrom) {
        const masterKeyList = currentField.getListFrom.split(",");
        masterKeyList.map((key) => {
          if (key == fieldName && dataToReset[key]) {
            delete dataToReset[currentField.dataKey];
          }
        });
      }
      if (
        !listError &&
        fieldData[currentField.dataKey] &&
        currentField.controlType != "datepicker" &&
        currentField.getListFrom == undefined
      ) {
        dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
      }
      return null;
    });

    dataToReset[fieldName] = newValue;
    this.setState({
      fieldData: dataToReset,
    });
  };

  render() {
    const { beatList } = this.props;
    const {
      dynamicMasterData,
      allChecked,
      tabValue,
      salesTeamId,
      tabFlag2,
      tabFlag1,
      salesExecutivData,
      checkedBeatList,
      checkedBeatNames,
      areaListForName,
      salesTeamLocalityData,
      beatType,
      fieldData,
      formErrors,
    } = this.state;

    const beatAllowanceTypes =
      JSON.parse(localStorage.getItem("isShowBeatAllowanceTypesNames")) || {};

    const beatTypeNames = JSON.parse(localStorage.getItem("getBeatTypeNames"));

    const variable1 = beatTypeNames?.Type1 ?? "Working";
    const variable2 = beatTypeNames?.Type2 ?? "Non Working";

    let fieldMetaForAllowanceWise = assignBeatJson.fieldMetaForAllowanceWise.map(item => {
      if (item.controlType === "radiogroup" && item.dataKey === "type") {
        return {
          ...item,
          radioGroupItems: item.radioGroupItems.map(radio => {
            if (radio.value === "0") return { ...radio, label: variable1 };
            if (radio.value === "1") return { ...radio, label: variable2 };
            return radio;
          })
        };
      }
      return item;
    });

    return (
      <>
        <Paper
          sx={{
            padding: 2,
          }}
          elevation={0}
        >
          <LandingScreenHeader
            screenTitle={"Beat Configuration Allowance Wise"}
            showTable={false}
            showBackButton={false}
            showAddButton={false}
            onCancel={this.onCancel}
          />
          <Tabs
            onChange={this.handledChange}
            value={tabValue}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab
              disabled={tabFlag1 ? true : false}
              label={"Form 1"}
              {...this.a11yProps(0)}
            />

            <Tab
              disabled={tabFlag2 ? true : false}
              label={"Form 2"}
              {...this.a11yProps(1)}
            />
          </Tabs>
          <br />
          <SwipeableViews index={tabValue} onChangeIndex={this.handleChange}>
            <TabPanel value={tabValue} index={0}>

              <DynamicFormWithoutValidation
                getListById={this.getListById}
                getByIdApi={true}
                callApi={true}
                dynamicMasterData={dynamicMasterData}
                showBackToList={false}
                onDataChange={this.onDataChange}
                fieldData={fieldData}
                formErrors={formErrors}
                searchList={assignBeatJson.searchList}
                showSaveBtn={true}
                showSaveBtnMain={false}
                showTitle={false}
                screenTitle={""}
                fieldMeta={fieldMetaForAllowanceWise}
                showCancel={assignBeatJson.showCancel}
                apiBaseURL={assignBeatJson.apiBaseURL}
                showSaveNextBtn={assignBeatJson.showSaveNextBtn}
                saveBtnText={"Search"}
                onFormSave={this.onSearch}
              />
              {Object.keys(salesTeamLocalityData).length !== 0 && (
                <Grid container item xs={12} md={6} lg={6} spacing={2}>
                  <Grid item xs={3.8} sm={3.8}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label="Locality : "
                    />
                  </Grid>

                  <Grid item xs={8.2} sm={8.2}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16 }}
                      label={
                        salesTeamLocalityData &&
                          salesTeamLocalityData.locality !== null
                          ? salesTeamLocalityData.locality == 0
                            ? "Metro"
                            : "Non Metro"
                          : "-"
                      }
                    />
                  </Grid>
                </Grid>
              )}
              <br />

              {beatList?.beat.length !== 0 && (
                <>
                  <>
                    <LandingScreenHeader
                      screenTitle={""}
                      showSearchBox={true}
                      showTable={true}
                      showFilter={false}
                      showPdfDownload={false}
                      showExcelDownload={true}
                      onSearch={this.onSearchBox}
                      generateExcel={this.generateExcel}
                    />

                    <div
                      style={{
                        maxHeight: "550px",
                        overflowX: "auto",
                        maxWidth: "100%",
                        borderRadius: "10px",
                        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                        background: "#fff",
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "separate",
                          borderSpacing: 0,
                          fontFamily: "Segoe UI, Arial, sans-serif",
                          fontSize: "15px",
                          background: "#fff",
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              position: "sticky",
                              top: 0,
                              background: "#f7fafc",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.03)",
                              zIndex: 2,
                            }}
                          >
                            <th style={{ ...thStyle, width: "10px" }}>
                              <input
                                type="checkbox"
                                style={{
                                  transform: "scale(1.5)",
                                  margin: "0 8px",
                                }}
                                checked={allChecked}
                                onChange={this.handleAllCheckedClick}
                              />
                            </th>
                            <th style={{ ...thStyle, width: "65px" }}>
                              Sr. No.
                            </th>
                            <th style={{ ...thStyle, width: "95px" }}>
                              Beat Name
                            </th>
                            <th style={{ ...thStyle, width: "95px" }}>
                              Town Name
                            </th>
                            <th style={{ ...thStyle, width: "95px" }}>
                              Area Name
                            </th>
                            {beatType != 0 && (
                              <th style={{ ...thStyle, width: "85px" }}>
                                Beat Distance (KM)
                              </th>
                            )}
                            {beatType != 1 && (
                              <th style={{ ...thStyle, width: "185px" }}>
                                Beat Sub Type
                              </th>
                            )}
                            {beatType != 0 && (
                              <th style={{ ...thStyle, width: "80px" }}>
                                Rate per KM
                              </th>
                            )}
                            {beatType != 1 && (
                              <th style={{ ...thStyle, width: "80px" }}>DA</th>
                            )}
                            {beatType != 0 && (
                              <th style={{ ...thStyle, width: "80px" }}>TA</th>
                            )}
                            {beatType != 0 && beatType != 1 && (
                              <th style={{ ...thStyle, width: "80px" }}>
                                Total
                              </th>
                            )}
                            <th style={{ ...thStyle, width: "155px" }}>
                              Sales Team Name
                            </th>
                            <th style={{ ...thStyle, width: "70px" }}>
                              End User
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.getFilteredTableData(beatList?.beat).map(
                            (row, index) => (
                              <tr
                                key={row.id}
                                style={{
                                  background:
                                    index % 2 === 0 ? "#fafbfc" : "#fff",
                                  transition: "background 0.2s",
                                  borderBottom: "1px solid #eaeaea",
                                  cursor: "pointer",
                                  ":hover": { background: "#f1f5fa" },
                                }}
                              >
                                <td style={tdCenterStyle}>
                                  <input
                                    type="checkbox"
                                    style={{
                                      transform: "scale(1.5)",
                                      margin: "0 8px",
                                    }}
                                    checked={row.isChecked}
                                    onChange={(e) =>
                                      this.handleClick(e, row.id)
                                    }
                                  />
                                </td>
                                <td style={tdCenterStyle}>{index + 1}</td>
                                <td style={tdStyle}>{row.beatName}</td>
                                <td style={tdStyle}>{row.townName}</td>
                                <td style={tdStyle}>{row.areaName}</td>
                                {beatType != 0 && (
                                  <>
                                    {row.beatType == 1 ? (
                                      <td style={tdInputStyle}>
                                        <input
                                          type="number"
                                          name="distance"
                                          value={row.distance}
                                          onChange={(e) =>
                                            this.changeHandler(row, "distance")(e)
                                          }
                                          onWheel={(e) => e.target.blur()}
                                          placeholder="Beat Distance"
                                          style={inputBoxStyle}
                                        />
                                        {row.distanceError && (
                                          <div style={errorStyle}>
                                            {row.distanceError}
                                          </div>
                                        )}
                                      </td>
                                    ) : (
                                      <td style={tdCenterStyle}>{"-"}</td>
                                    )}
                                  </>
                                )}

                                {beatType != 1 && (
                                  <>
                                    {row.beatType == 1 ? (
                                      <td style={tdCenterStyle}>{"-"}</td>
                                    ) : (
                                      <>
                                        <td style={tdStyle}>
                                          <label style={radioLabelStyle}>
                                            <input
                                              type="radio"
                                              name={`beatType-${row.id}`}
                                              style={{
                                                transform: "scale(1.5)",
                                                margin: "0 8px",
                                              }}
                                              value="0"
                                              checked={row.beatSubType == 0}
                                              onChange={(e) =>
                                                this.changeRadioHandler(
                                                  e,
                                                  row.id
                                                )
                                              }
                                            />
                                            <span style={radioTextStyle}>
                                              {beatAllowanceTypes?.beatType1 ||
                                                "-"}
                                            </span>
                                          </label>
                                          <label style={radioLabelStyle}>
                                            <input
                                              type="radio"
                                              name={`beatType-${row.id}`}
                                              style={{
                                                transform: "scale(1.5)",
                                                margin: "0 8px",
                                              }}
                                              value="1"
                                              checked={row.beatSubType == 1}
                                              onChange={(e) =>
                                                this.changeRadioHandler(
                                                  e,
                                                  row.id
                                                )
                                              }
                                            />
                                            <span style={radioTextStyle}>
                                              {beatAllowanceTypes?.beatType2 ||
                                                "-"}
                                            </span>
                                          </label>
                                        </td>
                                      </>
                                    )}
                                  </>
                                )}
                                {beatType != 0 && (
                                  <>
                                    {row.beatType == 1 ? (
                                      <td style={tdInputStyle}>
                                        <input
                                          type="number"
                                          name="ratePerKm"
                                          value={row.ratePerKm}
                                          onChange={(e) =>
                                            this.changeHandler(row, "ratePerKm")(e)
                                          }
                                          onWheel={(e) => e.target.blur()}
                                          placeholder="Rate Per KM"
                                          style={inputBoxStyle}
                                        // disabled={row.beatType == 0}
                                        />
                                        {row.ratePerKmError && (
                                          <div style={errorStyle}>
                                            {row.ratePerKmError}
                                          </div>
                                        )}
                                      </td>

                                    ) : (
                                      <td style={tdCenterStyle}>{"-"}</td>
                                    )}

                                  </>
                                )}
                                {beatType != 1 && (
                                  <>
                                    {
                                      row.beatType == 1 ? (
                                        <td style={tdCenterStyle}>{"-"}</td>
                                      ) : (

                                        <td style={tdInputStyle}>
                                          <input
                                            type="number"
                                            name="dailyAllowance"
                                            value={row.dailyAllowance}
                                            onChange={(e) =>
                                              this.changeHandler(
                                                row,
                                                "dailyAllowance"
                                              )(e)
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            placeholder="DA"
                                            style={inputBoxStyle}
                                          />
                                          {row.dailyAllowanceError && (
                                            <div style={errorStyle}>
                                              {row.dailyAllowanceError}
                                            </div>
                                          )}
                                        </td>
                                      )
                                    }
                                  </>
                                )}
                                {beatType != 0 && (
                                  <td style={tdRightStyle}>
                                    {(+row.ratePerKm * +row.distance).toFixed(
                                      2
                                    )}
                                  </td>
                                )}
                                {beatType != 0 && beatType != 1 && (
                                  <td style={tdRightStyle}>
                                    {(
                                      +row.dailyAllowance +
                                      +row.ratePerKm * +row.distance
                                    ).toFixed(2)}
                                  </td>
                                )}
                                <td style={tdCenterStyle}>
                                  {row.salesTeamName !== "-"
                                    ? row.salesTeamName
                                    : "-"}
                                </td>
                                <td style={tdCenterStyle}>
                                  <input
                                    type="checkbox"
                                    style={{
                                      transform: "scale(1.5)",
                                      margin: "0 8px",
                                    }}
                                    checked={row.isCheckedForEndUser}
                                    onChange={(e) =>
                                      this.handleClickOnEndUser(e, row.id)
                                    }
                                    disabled={row.isSelfAssign === 2}
                                  />
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>

                  <br />
                  <Grid
                    item
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    rowSpacing={2}
                    columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                    container
                    justifyContent="right"
                  >
                    <ButtonCompo
                      size="medium"
                      type="submit"
                      variant="contained"
                      name="Submit"
                      onClick={this.onSubmit}
                    />
                  </Grid>
                </>
              )}
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
              <BeatAssignationBySalesTeamWise
                padding={false}
                paddingTop={false}
                screenTitle={""}
                salesTeamId={salesTeamId}
                checkedBeatList={checkedBeatList}
                salesExecutivData={salesExecutivData}
                checkedBeatNames={checkedBeatNames}
                areaListForName={areaListForName}
              />
            </TabPanel>
          </SwipeableViews>
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  areaList: state.area,
  salesExecutive: state.salesExecutive,
  beatList: state.beat,
  stockStakeHolderTypeList: state.stockStakeHolderType,
});
const mapDispatchToProps = {
  getAreaByUserType,
  getRegionUpdated,
  getSalesExecutiveTypeByUserTypeIdsAndAreaId,
  getBeatByBeatTypeAndAreas,
  getStateByRegion,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getAreaByUserAndSalesTeamIds,
  getStateByRegion,
  getOutletByBeatId,
  showLoador,
  showNotification,
  setBeatBySalesTeamIdAreaId,
  setBeatList,
  getStockStakeHolderByOrderLevelWithSelf,
  getStockStakeHolderType,
  getSalesExecutive,
  getSalesExecutiveByUserAndStockHolderType,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignBeatAllowanceWiseForm);

const thStyle = {
  padding: "12px 8px",
  background: "#f7fafc",
  color: "#1a237e",
  fontWeight: 600,
  borderBottom: "2px solid #e0e0e0",
  textAlign: "center",
  fontSize: "15px",
  letterSpacing: "0.02em",
  borderRight: "1px solid #e0e0e0", // Add this line!
};

const tdStyle = {
  padding: "10px 8px",
  borderBottom: "1px solid #eaeaea",
  textAlign: "left",
  fontSize: "15px",
  verticalAlign: "middle",
  borderRight: "1px solid #e0e0e0", // Add this line!
};

const tdCenterStyle = {
  ...tdStyle,
  textAlign: "center",
};

const tdRightStyle = {
  ...tdStyle,
  textAlign: "right",
};

const tdInputStyle = {
  ...tdStyle,
  minWidth: "120px",
};

const inputBoxStyle = {
  width: "90px",
  padding: "4px 8px",
  borderRadius: "4px",
  border: "1px solid #cfd8dc",
  fontSize: "15px",
  outline: "none",
  background: "#f9f9fb",
};

const errorStyle = {
  color: "#e53935",
  fontSize: "12px",
  marginTop: "2px",
};

const radioLabelStyle = {
  marginRight: "12px",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
};

const radioTextStyle = {
  marginLeft: "4px",
};
